import React from "react";
import styled from "styled-components";

const InputText = styled.input.attrs(props => ({
  // we can define static props
  type: "text",
  // or we can define dynamic ones
  size: props.size || "40px"
}))`
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  padding-left: 10px;
  width: ${props => props.width || "100%"};
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  border-color: ${props => props.theme.color4};
  margin-top: 5px;
  margin-bottom: 5px;
  ::placeholder {
    color: ${props => props.theme.borderColor};
  }
`;

const WithValidation = styled.span`
  width: ${props => props.width || "100%"};
`;
const ErrorBox = styled.div`
  width: 100%;
  color: red;
`;

export default React.forwardRef((props, ref) => {
  return (
    <WithValidation width={props.width}>
      <InputText
        {...props}
        ref={ref}
        onKeyDown={
          props.onKeyDown
            ? props.onKeyDown
            : e => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  if (props.onBlur) {
                    props.onBlur();
                  }
                }
              }
        }
      ></InputText>
      {props.error && <ErrorBox>{props.error}</ErrorBox>}
    </WithValidation>
  );
});
